module.exports = __webpack_public_path__ + "img/Teknon.b383a011.png";